//@flow

import React, { Component } from 'react';
import AdobeClearSpace from './AdobeClearSpace';

class Background extends Component {
    render() {
        return (
            <div>
                <div className="background" />
                <AdobeClearSpace className="adobe-logo" />
            </div>
        );
    }
}

export default Background;



// WEBPACK FOOTER //
// ./src/components/Background/Background.js